import { StyleSheet } from 'aphrodite';
import { header, titles } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
	},
	infoIcon: {
		height: 14,
		marginLeft: 4,
		width: 14,
	},
	recipientCountHeader: {
		color: header,
		display: 'flex',
		gap: 4,
		margin: 0,
		fontSize: 14,
	},
	recipientCountLabel: {
		minWidth: 92,
	},
	recipientCountResult: {
		color: titles,
	},
});
